<template>
  <div>
    <section class="bg-lightgrey mt-5">
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row pb-100 pt-100 mt-5">
            <div class="col-lg-12">
              <h1 class="display-3">
                What Ifs
                <span>Achieving future readiness going forward</span>
              </h1>
              <p class="lead">
                Explore how a city's future readiness would strengthen if one or
                several of its key pillars improved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="">
      <div class="">
        <div
          class="text-center mw-100 px-5 pt-5"
          style="margin: auto"
          v-if="isMobile"
        >
          <i class="fa fa-mobile-phone fa-rotate-90 fa-3x"></i>
          <br />
          <p class="font-weight-500">
            This section is best viewed in landscape mode
          </p>
        </div>
        <section class="section" v-if="selectedCity === 'none'">
          <div class="container">
            <div class="row row-grid align-items-center">
              <div class="col-12">
                <WhatIfsTable @clickedCity="selectCity"></WhatIfsTable>
              </div>
            </div>
          </div>
        </section>
        <section class="section" v-if="selectedCity !== 'none'">
          <div class="container">
            <div class="row row-grid align-items-center">
              <div class="col-12">
                <WhatIfsTableCity
                  @clickedCity="selectCity"
                  :selectedCity="selectedCity"
                ></WhatIfsTableCity>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import WhatIfsTable from "@/views-2025/components-2025/WhatIfsTable";
import WhatIfsTableCity from "@/views-2025/components-2025/WhatIfsTableCountry";

export default {
  name: "WhatIfs",
  components: {
    WhatIfsTable,
    WhatIfsTableCity,
  },
  data() {
    return {
      selectedCity: "none",
    };
  },
  metaInfo: {
    title: "Portulans Institute CFRI 2025 | What Ifs",
  },
  methods: {
    selectCity(city) {
      this.selectedCity = city;
    },
  },
  computed: {
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
